/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const PLANOGRAM_CHANGE_DETAILS_FRAGMENT = gql`
  fragment PlanogramChangeDetails on PlanogramChange {
    id
    created
    completedAt
    completedBy {
      id
      firstName
      lastName
    }
    changedBy {
      id
      firstName
      lastName
    }
    diff {
      summary {
        productsAdded
        productsRemoved
        facingsIncreased
        facingsDecreased
      }
      products {
        upc
        changeType
        previousFacingCount
        newFacingCount
      }
    }
    previousPlanogram {
      shapedUpcs
    }
    newPlanogram {
      shapedUpcs
    }
  }
`
